<template>

    <div class="fc__container">
        <header class="fc__header">
            <div>
                <img src="/internacional/public/office3/img/dashboard/2020/template_club.svg" alt="Funnel Club" width="50">
                <div>
                    <h1> {{ t.title_template_club }} </h1>
                    <span> {{ t.profile_geral }} </span>
                </div>
            </div>
        </header>
        <section class="fc__content">
            <ul class="fc__cards">
                <li class="fc__card" v-for="submenu in submenus" :key="submenu.id">
                    <div>
                        <img :src="'/internacional/public/office4/img/franchise/submenus/svg/'+submenu.image">
                    </div>
                    <div>
						<div>
							<h2 v-html="submenu.title" ></h2>
                        	<p v-html="submenu.description"></p>
						</div>
                        <a :href="submenu.href" :target="submenu.target || '_self'"> {{ t.btn_tool_enter }} </a>
                    </div>
                </li>
            </ul>
        </section>
    </div>

</template>


<script>

export default {
	props: {
		t: Object, // translations
		submenus: Array,
	},
}
</script>


<style scoped lang="scss">
* {
    font-family: Mulish;
}
.fc__container {
	padding: 2%;

	.fc__header {
		display: flex;
		justify-content: center;
		margin: 30px 0;
		> div {
			display: flex;
			align-items: center;
			img {
				margin-right: 26px;
			}
			h1 {
				font-weight: bold;
				font-size: 30px;
				line-height: 38px;
				color: #5B5B5B;
				margin-bottom: 5px;
				margin-top: 0;
			}
			span {
				font-size: 14px;
				line-height: 17px;
				color: #818A91;
				font-family: Lato;
			}
		}
	}
	.fc__content {
		max-width: 1560px;
		margin: auto;
		.fc__cards {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			.fc__card {
				display: flex;
				flex: 1 1 400px;
				padding: 45px 20px;
				max-width: 500px;
				border-bottom: 1px solid rgba(0, 0, 0, 0.1);
				@media screen and (max-width: 576px) {
					flex-direction: column;
					text-align: center;
					img {
						margin-bottom: 10px;
						width: 110px !important;
					}
				}
				div {
					&:nth-child(1) {
						img {
							width: 150px;
							padding: 10px;
							transition: 0.6s;
							&:hover {
								transform: scale(1.06);
							}
						}
					}
					&:nth-child(2) {
						padding: 0 14px;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						flex: 1;
						h2 {
							width: 100%;
							border-bottom: 1px solid rgba(0, 0, 0, 0.5);
							color: #000;
							padding-bottom: 6px;
							margin: 0;
							font-size: 18px;
							line-height: 23px;
						}
						p {
							padding-top: 20px;
							font-family: Mulish;
							color: #818A91;
							font-size: 16px;
							line-height: 23px;
						}
						a {
							background: #EDF0F5;
							color: #0080FC;
							font-size: 20px;
							padding: 13px;
							width: 100%;
							display: block;
							text-align: center;
							border-radius: 8px;
							transition: .3s;
							&:hover {
								background: #0080FC;
								color: #fff;
							}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/funnel-club/FunnelClub.vue